<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    v-model="show"
    width="900"
    :fullscreen="$vuetify.display.width <= 600 ? true : false"
    class="public-style"
    destroy-on-close
    align-center
    @close="close"
  >
    <el-form
      ref="ruleFormRef"
      :model="logData"
      :style="[$vuetify.display.width < 600 ? 'height: 550;' : '']"
      :label-position="`top`"
    >
      <el-space fill style="width: 100%">
        <el-alert type="info" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Motion Bucket Download Details</p>
        </el-alert>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="user_full_name" label="User Full Name:">
              <el-input v-model="logData.user_full_name" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="user_email" label="User Email:">
              <el-input v-model="logData.user_email" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="form_kind" label="Form Kind:">
              <el-input v-model="logData.form_kind" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="action_kind" label="Action Kind:">
              <el-input v-model="logData.action_kind" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="log_date" label="Log Date:">
              <el-input :value="formatDateTime(logData.log_date)" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item class="label-style" prop="comment" label="Comment:">
              <el-input v-model="logData.comment" type="textarea" :rows="2" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-alert type="warning" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Downloaded Files</p>
        </el-alert>

        <template v-if="parseError">
          <el-alert type="error" :title="parseError" show-icon />
        </template>

        <div v-else class="custom-table-design">
          <el-table
            :data="downloadedFiles"
            stripe
            style="width: 100%"
            max-height="300"
            class="my-2 data-table"
          >
            <el-table-column prop="file_id" label="File ID" min-width="100" />
            <el-table-column prop="file_name" label="File Name" min-width="220" />
            <el-table-column prop="category" label="Category" min-width="160">
              <template #default="scope">
                {{ formatCategory(scope.row.category) }}
              </template>
            </el-table-column>
            <el-table-column prop="file_created_at" label="File Created At" min-width="180">
              <template #default="scope">
                {{ formatDateTime(scope.row.file_created_at) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-space>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="medium"
          class="me-primary"
          @click.stop="close"
          color="#ddf0ac"
        >
          <i class="fa fa-times me-2 me-primary"></i>
          <span class="moderat-btn-apply">Close</span>
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    data_modal: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      show: this.open_modal,
      logData: {
        user_full_name: "",
        user_email: "",
        form_kind: "",
        action_kind: "",
        log_date: "",
        comment: "",
      },
      downloadedFiles: [],
      parseError: "",
    };
  },
  watch: {
    open_modal(newVal) {
      this.show = newVal;
      if (newVal === true) {
        this.parseModalData();
      }
    },
  },
  methods: {
    parseModalData() {
      this.parseError = "";
      this.downloadedFiles = [];
      if (!this.data_modal) return;

      this.logData = {
        user_full_name: this.data_modal.user_full_name ?? "",
        user_email: this.data_modal.user_email ?? "",
        form_kind: this.data_modal.form_kind ?? "",
        action_kind: this.data_modal.action_kind ?? "",
        log_date: this.data_modal.log_date ?? "",
        comment: this.data_modal.comment ?? "",
      };

      try {
        const raw = this.data_modal.before_change;
        const details = typeof raw === "string" ? JSON.parse(raw) : raw;
        this.downloadedFiles = Array.isArray(details?.files) ? details.files : [];
      } catch (error) {
        this.parseError = "Could not parse downloaded file details.";
      }
    },
    formatCategory(category) {
      const labels = {
        sessions: "Sessions",
        "unallocated-sessions": "Unallocated sessions",
        "sessions-with-abatement": "Sessions with abatement",
        "charger-logs": "Charger logs",
        auditor: "Auditor",
        other: "Other",
      };
      return labels[category] || category || "";
    },
    formatDateTime(dateStr) {
      if (!dateStr) return "";
      try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return String(dateStr);
        const pad = (value) => String(value).padStart(2, "0");
        return [
          date.getFullYear(),
          pad(date.getMonth() + 1),
          pad(date.getDate()),
        ].join("-") + " " + [
          pad(date.getHours()),
          pad(date.getMinutes()),
          pad(date.getSeconds()),
        ].join(":");
      } catch (error) {
        return String(dateStr);
      }
    },
    close() {
      this.show = false;
      this.$emit("close_modal", false);
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 30px 10px;
}
.el-input__inner {
  padding: 0 10px !important;
}
.alert-style {
  margin-bottom: 10px;
}
</style>
